import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgSwap = ({ size = "regular", className = "", ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6.369 4.661a9.25 9.25 0 0 1 14.566 4.945.75.75 0 0 1-1.449.388A7.75 7.75 0 0 0 5.039 8.593l3.014-1.004a.75.75 0 0 1 .474 1.423l-4.5 1.5a.75.75 0 0 1-.97-.55l-1-4.5a.75.75 0 0 1 1.465-.325l.489 2.2a9.3 9.3 0 0 1 2.358-2.676m-2.773 8.814a.75.75 0 0 1 .918.53 7.75 7.75 0 0 0 14.447 1.402l-3.013 1.005a.75.75 0 1 1-.475-1.424l4.5-1.5a.75.75 0 0 1 .97.55l1 4.5a.75.75 0 0 1-1.465.325l-.489-2.2a9.25 9.25 0 0 1-16.924-2.269.75.75 0 0 1 .53-.918"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgSwap;
